export function thumbURL (filename: string): string {
  return `https://www.bide-et-musique.com/images/thumb150/${filename}`
}

export function coverURL (filename: string): string {
  return `https://www.bide-et-musique.com/images/pochettes/${filename}`
}
